import { refreshToken } from 'features/auth/services/tokenService';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import store from 'store';

const REFRESH_BEFORE_MS = 5 * 60 * 1000;
const MAX_TIMEOUT_MS = 2_147_483_647;

// Renews the JWT 5 minutes before it ends while the app is open; the 401 replay stays as the fallback.
const useProactiveTokenRefresh = (token: string | null | undefined) => {
  useEffect(() => {
    if (!token) return;

    let expiresAt: number;
    try {
      expiresAt = (jwtDecode(token).exp ?? 0) * 1000;
    } catch {
      return;
    }
    if (!expiresAt) return;

    const renewIfDue = () => {
      if (Date.now() >= expiresAt - REFRESH_BEFORE_MS) void refreshToken(store);
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') renewIfDue();
    };

    const delay = Math.max(0, expiresAt - REFRESH_BEFORE_MS - Date.now());
    const timer = setTimeout(renewIfDue, Math.min(delay, MAX_TIMEOUT_MS));
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [token]);
};

export default useProactiveTokenRefresh;
